import { AxiosInstance, AxiosResponse, GenericAbortSignal } from 'axios';
import { ProjectAccessControlPolicyAuthorizeDto } from './inputs/project-access-control-policy-authorize.input';
import { ProjectAccessControlPolicyUpdatePasswordDto } from './inputs/project-access-control-policy-password.input';
import { ProjectAccessControlPolicyUpdateSettingsDto } from './inputs/project-access-control-policy-settings.input';
import { ProjectCloneDto } from './inputs/project-clone.input';
import { ProjectCreateDto } from './inputs/project-create.input';
import { ProjectUpdateDto } from './inputs/project-update.input';
import { ProjectAccessControlPolicyAuthorizeResponse } from './responses/project-access-control-policy-authorize.response';
import { ProjectAccessControlPolicyEntryResponse } from './responses/project-access-control-policy-entry.response';
import { ProjectDeleteResponse } from './responses/project-delete.response';
import { ProjectEntryResponse } from './responses/project-entry.response';
export class ProjectsModuleClient {
  constructor(private readonly client: AxiosInstance) {}

  async createOne(dto: ProjectCreateDto): Promise<AxiosResponse<ProjectEntryResponse>> {
    return await this.client.post('/projects/', dto);
  }

  async cloneOne(dto: ProjectCloneDto): Promise<AxiosResponse<ProjectEntryResponse>> {
    return await this.client.post('/projects/clone', dto);
  }

  async getOne(
    id: string,
    signal?: GenericAbortSignal,
  ): Promise<AxiosResponse<ProjectEntryResponse>> {
    return await this.client.get(`/projects/${id}`, {
      signal,
    });
  }

  async getMany(): Promise<AxiosResponse<ProjectEntryResponse[]>> {
    return await this.client.get(`/projects/`);
  }

  async updateOne(id: string, dto: ProjectUpdateDto): Promise<AxiosResponse<ProjectEntryResponse>> {
    return await this.client.put(`/projects/${id}`, dto);
  }

  async deleteOne(id: string): Promise<AxiosResponse<ProjectDeleteResponse>> {
    return await this.client.delete(`/projects/${id}`);
  }

  async authorizeAccessControlPolicy(
    id: string,
    dto: ProjectAccessControlPolicyAuthorizeDto,
  ): Promise<AxiosResponse<ProjectAccessControlPolicyAuthorizeResponse>> {
    return await this.client.post(`/projects/access-control-policy/${id}/authorize`, dto);
  }

  async getProjectAccessControlPolicy(
    id: string,
  ): Promise<AxiosResponse<ProjectAccessControlPolicyEntryResponse>> {
    return await this.client.get(`/projects/${id}/access-control-policy`);
  }

  async updateProjectAccessControlPolicyPassword(
    id: string,
    dto: ProjectAccessControlPolicyUpdatePasswordDto,
  ): Promise<AxiosResponse<ProjectAccessControlPolicyEntryResponse>> {
    return await this.client.put(`/projects/access-control-policy/${id}/password`, dto);
  }

  async updateProjectAccessControlPolicySettings(
    id: string,
    dto: ProjectAccessControlPolicyUpdateSettingsDto,
  ): Promise<AxiosResponse<ProjectAccessControlPolicyEntryResponse>> {
    return await this.client.put(`/projects/access-control-policy/${id}/settings`, dto);
  }
}
